import React, { useEffect } from "react";
import "@fontsource-variable/dm-sans";
import "../../pages/Steffi/steffi.css";
import "../../pages/Steffi/steffi-sizing.css";
import { Link } from "react-router-dom";
import { FiAlertCircle } from "react-icons/fi";
import SteffiFace from "../../pages/Steffi/components/SteffiFace";

/* The family pages a visitor sees before they are signed in (invitation and
   login), in the homepage's look. steffi-sizing.css scales many size utilities
   under .steffi down to 80 %, so text sizes here use classes it leaves alone
   (text-base, text-lg, text-[1.875rem]). */

export const FIELD =
  "w-full rounded-full border border-[color:var(--border)] bg-[color:var(--bg)] px-6 py-4 text-[color:var(--ink)] outline-none transition placeholder:text-[color:var(--ink-3)] focus:border-[color:var(--accent)]";
export const QUIET_LINK =
  "text-base font-medium text-[color:var(--ink-3)] underline-offset-4 transition hover:text-[color:var(--color-primary)] hover:underline";
export const HEADING = "text-[1.875rem] leading-[1.1]";
export const LEAD = "mt-4 text-lg leading-relaxed text-[color:var(--ink-2)]";

export function FormError({ children }) {
  return (
    <p role="alert" className="flex items-start gap-2 px-4 text-base leading-snug text-[#a4593f]">
      <FiAlertCircle aria-hidden className="mt-0.5 shrink-0" /> {children}
    </p>
  );
}

/* The face from the homepage on the dark display glass, as in the family app. */
function SteffiDisc() {
  return (
    <span
      className="mx-auto block h-24 w-24 rounded-full bg-[#2C0A29]"
      style={{ boxShadow: "0 22px 44px -22px rgba(92, 26, 86, 0.75)" }}
    >
      <SteffiFace />
    </span>
  );
}

export default function FamilyAuthLayout({ documentTitle, children }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = documentTitle;
    return () => {
      document.title = previousTitle;
    };
  }, [documentTitle]);

  return (
    <main className="steffi flex min-h-screen flex-col" style={{ background: "var(--bg)" }}>
      <header className="mx-auto flex h-[61px] w-full max-w-[1440px] items-center px-6 lg:px-10">
        <Link to="/" className="flex items-center gap-3 transition-opacity duration-500 hover:opacity-70">
          <img src="/steffi/logo.png" alt="" aria-hidden className="brand-logo h-9 w-9" />
          <span className="display wordmark text-[1.125rem] tracking-[-0.01em]" style={{ fontWeight: 700 }}>
            SteffiCare
          </span>
        </Link>
      </header>

      <div className="flex flex-1 items-center justify-center px-4 pb-16 pt-6">
        <div
          className="card relative w-full max-w-[28rem] px-7 py-9 text-center sm:px-10"
          style={{ borderRadius: 32, boxShadow: "0 40px 90px -40px rgba(36,33,30,.45)" }}
        >
          <SteffiDisc />
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </main>
  );
}
